import React, { useState, useRef, useEffect, useContext } from 'react';
import { BsThreeDotsVertical } from "react-icons/bs";
import { Link } from 'react-router-dom'
import useStyles from './styles'
import api from '../../services/api';
import OptionsBaloom from '../OptionsBaloom';
import appContext from '../../redux/contexts/appContext'
import Modal from '../Modal';

function RoomCard({title, code, people, image, id, description, creatorId, onRoomRemove, isLoading}) {
  const classes = useStyles();

  const [isOptsOpen, setOptsOpen] = useState(false);
  const compRef = useRef(null);
  const {state, dispatch} = useContext(appContext);

  const [deleteModal, setDeleteModal] = useState(false);
  const [exitModal, setExitModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const [alertModal, setAlertModal] = useState(null);

  const handleOutsideClick = (event) => {
    if (compRef.current && !compRef.current.contains(event.target)) {
      setOptsOpen(false);
    }
  }
  

  const onExit = () => {
    setOptsOpen(false);
    setLoading(true);
    closeModal();
    if (onRoomRemove) onRoomRemove(id);

    api().delete(`/room/${code}/member/${state.user.id}/remove`)
    .then(res => {
      setLoading(false);
    })
    .catch(err => {
      setLoading(false);
      closeModal();
      if (err?.response?.data?.msg) {
        setAlertModal(err.response.data.msg);
      }
      else {
        setAlertModal("Internal Server Error");
      }
    })
  }

  const onDelete = () => {
    setOptsOpen(false);
    setLoading(true);
    closeModal();
    if (onRoomRemove) onRoomRemove(id);

    api().delete(`/room/${id}`)
    .then(res => {
      setLoading(false);
    })
    .catch(err => {
      setLoading(false);
      if (err?.response?.data?.msg) {
        setAlertModal(err.response.data.msg);
      }
      else {
        setAlertModal("Internal Server Error");
      }
    })
  }

  const closeModal= () => {
    setExitModal(false);
    setDeleteModal(false);
  }

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
  }, []);



  return (
    <>
      <div className={classes.cardContainer} ref={compRef} style={state.theme === "dark" ? {backgroundColor: '#1e1e1e', color: 'white'} : {}}>
        <div  className={classes.cardTop} style={state.theme === "dark" ? {backgroundColor: '#1e1e1e', color: 'white'} : {}}>
          <Link to={id && id != "" ? "/room/"+id:"/"}></Link>
          <div className={classes.topHeading} >
            <span className={isLoading ? "loading-light" : ""} style={{minWidth: 100, minHeight: 24}}>{title || ""}</span>
            {onRoomRemove && (
              <div className={classes.dots} onClick={() => setOptsOpen(!isOptsOpen)}>
                <BsThreeDotsVertical ></BsThreeDotsVertical>
                <OptionsBaloom 
                open={isOptsOpen} 
                options={creatorId == state.user.id ? [{text: "Delete", onClick: () => setDeleteModal(true)}] : [{text: "Exit", onClick: () => setExitModal(true)}]} 
                />
                
              </div>
            )}
            
          </div>
          
          <div className={classes.botHeading}>
            <span className={isLoading ? "loading-light" : ""} style={{minWidth: 30, minHeight: 14}}>{code.toUpperCase()}</span>
          </div>
        </div>
        <div className={classes.cardContent + (isLoading ? " loading-light" : "")} style={{minHeight: 50}} title={description || ""}>{description || ""}</div>
      </div>
      <Modal loading={loading} autoHeight title="Delete Room" visible={deleteModal} onCancel={closeModal} onSubmit={() => onDelete()}>
          Do you really want to delete this room?
      </Modal>
      <Modal loading={loading} autoHeight title="Exit Room" visible={exitModal} onCancel={closeModal} onSubmit={() => onExit()}>
          Do you really want to exit this room?
      </Modal>
      <Modal visible={alertModal !== null} title={"Alert"} onCancel={() => setAlertModal(null)} onSubmit={() => setAlertModal(null)} cancelText={false} >
        {alertModal}
      </Modal>
    </>
  );
}

export default RoomCard;